import "mmenu-js";

// fire mmenu-js:
document.addEventListener("DOMContentLoaded", () => {
  new Mmenu("#mmenu", {
    // options
    offCanvas: {
      position: "left-front",
    },
  });
});
